import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { TestExecutionStatus } from '@flowqa/shared';

export type CloneSortDirection = 'asc' | 'desc';
export type CloneSortKey =
  | 'name'
  | 'suiteId'
  | 'latestExecutionTimestamp'
  | 'metrics.passRate'
  | 'metrics.passRateDelta'
  | 'metrics.frequencyPerDay'
  | 'metrics.frequencyPerDayDelta'
  | 'metrics.averageDurationMs'
  | 'metrics.averageDurationMsDelta';

export const cloneDefaultSortKey: CloneSortKey = 'latestExecutionTimestamp';
export const cloneDefaultSortDirection: CloneSortDirection = 'desc';

export const cloneSortOptions: Array<{ key: CloneSortKey; label: string }> = [
  { key: 'name', label: 'Test Name' },
  { key: 'suiteId', label: 'Suite Name' },
  { key: 'latestExecutionTimestamp', label: 'Latest' },
  { key: 'metrics.passRate', label: 'Pass Rate' },
  { key: 'metrics.passRateDelta', label: 'Pass Rate Delta' },
  { key: 'metrics.frequencyPerDay', label: 'Frequency' },
  { key: 'metrics.frequencyPerDayDelta', label: 'Frequency Delta' },
  { key: 'metrics.averageDurationMs', label: 'Avg. Duration' },
  { key: 'metrics.averageDurationMsDelta', label: 'Avg. Duration Delta' },
];

export const cloneSortFieldMap: Record<CloneSortKey, string> = {
  name: 'name',
  suiteId: 'slug',
  latestExecutionTimestamp: 'latestExecutionTimestamp',
  'metrics.passRate': 'executionPassRate',
  'metrics.passRateDelta': 'executionPassRateDelta',
  'metrics.frequencyPerDay': 'executionFrequencyPerDay',
  'metrics.frequencyPerDayDelta': 'executionFrequencyPerDayDelta',
  'metrics.averageDurationMs': 'executionAverageDurationMs',
  'metrics.averageDurationMsDelta': 'executionAverageDurationMsDelta',
};

export const cloneColumnOptions: Array<{ field: string; label: string; mandatory?: boolean }> = [
  { field: 'name', label: 'Test', mandatory: true },
  { field: 'latestExecutionStatus', label: 'Latest' },
  { field: 'metrics.passRate', label: 'Pass Rate' },
  { field: 'metrics.frequencyPerDay', label: 'Frequency' },
  { field: 'metrics.averageDurationMs', label: 'Average Duration' },
  { field: 'actions', label: 'Actions' },
];

export const cloneStatusOptions: Array<{ value: TestExecutionStatus; label: string }> = [
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'errored', label: 'Errored' },
  { value: 'skipped', label: 'Skipped' },
];

export const cloneDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  suiteId: false,
  tags: false,
  statusFilter: false,
  latestExecutionStatus: true,
  latestExecutionDurationMs: false,
  latestExecutionTimestamp: false,
  'metrics.passRate': true,
  'metrics.frequencyPerDay': true,
  'metrics.averageDurationMs': true,
  actions: true,
};
